import { LegalContext } from '~/machines/legal-completion';
import { SolarFunnelContext, solarMachine } from '~/machines/solar-funnel';
import { UploadContext } from '~/machines/upload';
import { UserContext } from '~/machines/user-creation';
import { ContractTag } from '~/typings/graphql';
import { UTILITY_IDS } from '~/utils/constants';
import { getInitialState } from '~/utils/funnels';
import { oregonFunnelRedirects } from '~/utils/redirects';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    utility: {
      context: { redirect: oregonFunnelRedirects },
    },
    user: {
      context: { requirePhone: true, showInviteCode: true },
    },
    legal: {
      context: {
        contractTags: context => {
          switch (context.funnelPacket.utility.id) {
            case UTILITY_IDS['Portland General Electric']:
              return [ContractTag.OregonTier_2LmiPge];
            case UTILITY_IDS['Pacific Power OR']:
              return [ContractTag.OregonTier_2LmiPp];
            default:
              return [];
          }
        },
      },
    },
  }).withConfig({
    guards: {
      isUserFromOregonLmi: context => isUserFromOregonLmi(context),
    },
  });

export const isUserFromOregonLmi = (
  context: SolarFunnelContext | LegalContext | UploadContext | UserContext,
) => context?.funnelId === config.id;
